import { ListReconciliationMismatchesResponse } from '@cbinsights/salesforceservice/salesforceservice';
import { UseQueryResult, useQuery } from 'react-query';
import { ListReconciliationMismatches } from '.';
import { listReconciliationMismatches } from '../api/ListReconciliationMismatches';

type Params = Parameters<typeof listReconciliationMismatches>[0];
type Return = ListReconciliationMismatchesResponse;

export const useGetReconciliationMismatchesQuery = ({
  enabled = false,
  params,
}: {
  enabled: boolean;
  params: Params;
}): UseQueryResult<Return, Error> =>
  useQuery<Return, Error, Return, [ListReconciliationMismatches, Params]>(
    ['ListReconciliationMismatches', params],
    () => listReconciliationMismatches(params),
    {
      enabled,
      notifyOnChangeProps: ['data', 'isFetching'],
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
    }
  );
